namespace cdh {


    function getUserConfigMethods(target: KnockoutReadonlyObservable<IUserContext>): IUserContextExtensions {

        let _options = createDictionary(ko.computed(() => {
            let t = ko.unwrap(target);

            if (t && t.options)
                return ko.unwrap(t.options);
            else
                return null;
        }), "key");

        var ext: IUserContextExtensions = {

            getOptions: (key: string) => {
                let kvs = _options.findItem(key);
                return kvs ? kvs.value : null;
            }
        };

        return ext;
    }

    function getNotificationConfigMethods(target: KnockoutReadonlyObservable<notification.INotificationFeatureConfig>): INotificationContextExtensions {

        var hasError = false;

        var ext: INotificationContextExtensions = {

            isEnabled: ko.pureComputed(() => {
                var cfg = target();

                if (cfg) {
                    var s = ko.unwrap(cfg.state);

                    return s == notification.ActivationState.Active;
                }
                return false;
            }),
            isExternal: ko.pureComputed(() => {
                return ext.isEnabled();
            }),
            hasError: ko.computed(() => {
                var cfg = target();

                if (cfg) {
                    var s = ko.unwrap(cfg.state);

                    hasError = s < 0;
                }
                return hasError;

            }).extend({ deferred: true })

        };

        //debugger;
        //ko.unwrap(ext.hasError);
        ext.hasError.subscribe(v => {
            if (v)
                ui.alertIcon(t("data/notifications/generalErrorMsg"), "warning");
        });

        return ext;
    }


    /** Observable that contains the current user configuration */
    export var userContext: KnockoutReloadable<IUserContext> & IUserContextExtensions;

    /** Observable that contains the current user configuration */
    export var notificationConfig: KnockoutReloadable<notification.INotificationFeatureConfig> & INotificationContextExtensions;

    export async function initConfig(prefix?: string) {
        if (!Router) return;

        if (userContext) return;

        let pArr: PromiseLike<any>[] = [];

        if (uid) {
            if (typeof (prefix) !== "string" || !prefix)
                prefix = "cdh.pmc";

            //config = utils.asyncCacheable({
            //    reloadFunc: (Router ? utils.getUrl("api/config") : null),
            //    storage: prefix + ".fcCtx"
            //}, getFeatureConfigMethods);
            //pArr.push(config.awaitResult());

            userContext = utils.asyncCacheable({
                reloadFunc: (Router ? utils.getUrl("api/config/usercontext") : null),
                storage: getUserCacheOptions(".usrCtx"),
            }, getUserConfigMethods);
            pArr.push(userContext.awaitResult());

            notificationConfig = utils.asyncCacheable({
                reloadFunc: (Router ? utils.getUrl("api/notification/config") : null),
                storage: getUserCacheOptions(".notCfg"),
            }, getNotificationConfigMethods);
            pArr.push(notificationConfig.awaitResult());
        }

        await utils.allWithFails<any>(...pArr);

        function getUserCacheOptions(name: string): utils.CacheStorageOptions<any> {
            if (!name) return null;

            if (name.charAt(0) != '.') name = "." + name;

            return {
                name: prefix + name,
                setData: cd => cd.uid = uid,
                checkData: cd => cd.uid == uid
            }
        }
    }

    // #endregion

    /** User specific Configuration Information */
    export interface IUserContext {

        userName: string;
        email: string;
        userId: number;

        // TODO Export FeatureConfig for User?
        options: { key: string, value: any }[];
    }

    /** Functions for checking user configuration */
    export interface IUserContextExtensions {
        /** searches an Option Object */
        // reload(): Promise<void>;
        getOptions(key: string): Readonly<any>;
    }

    /** Functions for checking notification configuration */
    export interface INotificationContextExtensions {
        readonly isEnabled: KnockoutReadonlyComputed<boolean>;
        readonly isExternal: KnockoutReadonlyComputed<boolean>;
        readonly hasError: KnockoutReadonlyComputed<boolean>;
    }
}